import { SoundOutlined, VideoCameraOutlined } from '@ant-design/icons';

function MediaTypeIcons() {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-center gx-w-100 gx-mb-5"
      style={{
        gap: 8,
      }}
    >
      <VideoCameraOutlined
        style={{
          fontSize: 32,
        }}
      />
      <SoundOutlined
        style={{
          fontSize: 32,
        }}
      />
    </div>
  );
}
export default MediaTypeIcons;
